const selectAuthProfile = (state) => state.authReducer.authProfile
const selectKycProfile = (state) => state.accountReducer.kycProfile
const selectAccountProfile = (state) => state.accountReducer.accountProfile
const selectMainProfile = (state) => state.mainReducer.mainProfile
const selectTokenProfile = (state) => state.mainReducer.tokenProfile
const selectStakingProfile = (state) => state?.stakingReducer?.stakingProfile
const selectWalletProfile = (state) => state.walletReducer.walletProfile
const selectExchangeProviderProfile = (state) =>
  state.exchangeReducer?.exchangeProviderProfile
const selectGameProfile = (state) => state.gameReducer.gameProfile
const selectEarnViaProfile = (state) => state.earnViaReducer.earnViaProfile
const selectReferralProfile = (state) => state.referralReducer.referralProfile

export {
  selectAuthProfile,
  selectKycProfile,
  selectAccountProfile,
  selectMainProfile,
  selectTokenProfile,
  selectStakingProfile,
  selectWalletProfile,
  selectExchangeProviderProfile,
  selectGameProfile,
  selectEarnViaProfile,
  selectReferralProfile
}
